import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AdminDownloadComponent } from './admin-download/admin-download.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AccountConfigComponent } from './accounts/account-config/account-config.component';
import { SharedModule } from '../../shared.module';
import { ServerConfigComponent } from './server-config/server-config/server-config.component';
import { ServerConfigItemComponent } from './server-config/server-config-item/server-config-item.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoginTrackerComponent } from './login-tracker/login-tracker.component';
import { AccountsComponent } from './accounts/accounts.component';
import { AccountEditComponent } from './accounts/account-edit/account-edit.component';
import { MoveCaseDialogComponent } from './accounts/move-case-dialog/move-case-dialog.component';
import { ManageUserAccessDialogComponent } from './accounts/manage-user-access-dialog/manage-user-access-dialog.component';
import { CreateAccountDialogComponent } from './accounts/create-account-dialog/create-account-dialog.component';
import { EmployeeRoleComponent } from './employee-role/employee-role.component';
import { ExportAccountsDialogComponent } from './accounts/export-accounts-dialog/export-accounts-dialog.component';
import { ManageCasePermissionDialogComponent } from './cases/manage-case-permission-dialog/manage-case-permission-dialog.component';
import { MaterialModule } from '../../core/material/material.module';
import { CasesComponent } from './cases/cases.component';
import { CaseEditComponent } from './cases/case-edit/case-edit.component';
import { CaseConfigComponent } from './cases/case-config/case-config.component';
import { UsersComponent } from './users/users.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { ExportUsersDialogComponent } from './users/export-users-dialog/export-users-dialog.component';
import { ManageAccountAccessDialogComponent } from './users/manage-account-access-dialog/manage-account-access-dialog.component';
import { ManageCaseAccessDialogComponent } from './users/manage-case-access-dialog/manage-case-access-dialog.component';
import { ManageAccountRolesDialogComponent } from './users/manage-account-roles-dialog/manage-account-roles-dialog.component';
import { UserEditDialogComponent } from './users/user-edit/user-edit-dialog/user-edit-dialog.component';
import { ReshardCaseIndexDialogComponent } from './cases/reshard-case-index-dialog/reshard-case-index-dialog.component';
import { ManageOpenAISettingDialogComponent } from './users/manage-open-ai-setting-dialog/manage-open-ai-setting-dialog.component';
import { ManageOpenAIAccountSettingDialogComponent } from './accounts/manage-open-ai-account-setting-dialog/manage-open-ai-account-setting-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		AdminRoutingModule,
		SharedModule,
		MatInputModule,
		MatFormFieldModule,
		ScrollingModule,
		MatButtonModule,
		MatSelectModule
	],
	declarations: [
		AdminDownloadComponent,
		AccountConfigComponent,
		ServerConfigComponent,
		ServerConfigItemComponent,
		LoginTrackerComponent,
		AccountsComponent,
		AccountEditComponent,
		MoveCaseDialogComponent,
		ManageUserAccessDialogComponent,
		CreateAccountDialogComponent,
		EmployeeRoleComponent,
		ExportAccountsDialogComponent,
		ManageCasePermissionDialogComponent,
		CasesComponent,
		CaseEditComponent,
		CaseConfigComponent,
		UsersComponent,
		UserEditComponent,
		ExportUsersDialogComponent,
		ManageAccountAccessDialogComponent,
		ManageCaseAccessDialogComponent,
		ManageAccountRolesDialogComponent,
		UserEditDialogComponent,
		ReshardCaseIndexDialogComponent,
		ManageOpenAISettingDialogComponent,
		ManageOpenAIAccountSettingDialogComponent
	],
	exports: []
})
export class AdminModule { }
